<template>
  <div class="main-wrapper">
    <layoutheader></layoutheader>
    <breadcrumb-doctor :title="'Admin Dashboard'" :text="'Dashboard'" :text1="'Manage Doctors'" />
    
    <!-- Page Content -->
    <div class="content">
      <div class="container">
        <div class="row">
          <!-- Sidebar (Optional) -->
          <div class="col-md-12">
            <!-- Stats Cards -->
            <div class="row">
              <div class="col-md-12">
                <div class="card dash-card">
                  <div class="card-body">
                    <div class="row">
                      <!-- Total Doctors Card -->
                      <div class="col-md-12 col-lg-4">
                        <div class="dash-widget dct-border-rht">
                          <div class="circle-bar circle-bar1">
                            <div class="circle-graph1">
                              <circle-progress :percent="100" />
                              <img src="@/assets/img/icon-01.png" class="img-fluid" alt="Total Doctors" />
                            </div>
                          </div>
                          <div class="dash-widget-info">
                            <h6>Total Doctors</h6>
                            <h3 v-if="!statsLoading">{{ stats.total }}</h3>
                            <span v-else class="spinner-border spinner-border-sm"></span>
                            <p class="text-muted">Till Today</p>
                          </div>
                        </div>
                      </div>

                      <!-- Active Doctors Card -->
                      <div class="col-md-12 col-lg-4">
                        <div class="dash-widget dct-border-rht">
                          <div class="circle-bar circle-bar2">
                            <div class="circle-graph2">
                              <circle-progress :percent="75" />
                              <img src="@/assets/img/icon-02.png" class="img-fluid" alt="Active Doctors" />
                            </div>
                          </div>
                          <div class="dash-widget-info">
                            <h6>Active Doctors</h6>
                            <h3 v-if="!statsLoading">{{ stats.active }}</h3>
                            <span v-else class="spinner-border spinner-border-sm"></span>
                            <p class="text-muted">Approved</p>
                          </div>
                        </div>
                      </div>

                      <!-- Pending Approvals Card -->
                      <div class="col-md-12 col-lg-4">
                        <div class="dash-widget dct-border-rht">
                          <div class="circle-bar circle-bar3">
                            <div class="circle-graph3">
                              <circle-progress :percent="50" />
                              <img src="@/assets/img/icon-03.png" class="img-fluid" alt="Pending" />
                            </div>
                          </div>
                          <div class="dash-widget-info">
                            <h6>Pending Approvals</h6>
                            <h3>{{ pendingDoctors }}</h3>
                            <p class="text-muted">Waiting</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Doctors Table Section -->
            <div class="row" style="margin-top: 20px;">
              <div class="col-md-12">
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px;">
                  <h3 style="margin: 0;">Manage Doctors</h3>
                  <button @click="logout" class="btn btn-danger btn-sm">
                    <i class="fas fa-sign-out-alt me-2"></i>Logout
                  </button>
                </div>

                <div class="row admin-workspace">
                  <div class="col-lg-3">
                    <div class="card admin-sidebar">
                      <div class="card-body">
                        <button
                          class="admin-nav-btn"
                          :class="{ active: adminPanel === 'doctors' }"
                          @click="adminPanel = 'doctors'"
                        >
                          <i class="fas fa-user-md"></i>
                          Doctors
                        </button>
                        <button
                          class="admin-nav-btn"
                          :class="{ active: adminPanel === 'clinics' }"
                          @click="adminPanel = 'clinics'"
                        >
                          <i class="fas fa-hospital"></i>
                          Clinics
                        </button>
                        <button
                          class="admin-nav-btn"
                          :class="{ active: adminPanel === 'assign-clinics' }"
                          @click="adminPanel = 'assign-clinics'"
                        >
                          <i class="fas fa-link"></i>
                          Assign Clinics
                        </button>
                        <button
                          class="admin-nav-btn"
                          :class="{ active: adminPanel === 'slots' }"
                          @click="adminPanel = 'slots'"
                        >
                          <i class="fas fa-calendar-plus"></i>
                          Generate Slots
                        </button>
                        <button
                          class="admin-nav-btn"
                          :class="{ active: adminPanel === 'cities' }"
                          @click="openCitiesPanel"
                        >
                          <i class="fas fa-city"></i>
                          Cities
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-9">
                    <div v-if="adminPanel === 'clinics'" class="card admin-tool-card">
                      <div class="card-body">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                          <h5 class="mb-0">Clinics</h5>
                          <button class="btn btn-primary btn-sm" @click="openClinicModal">
                            <i class="fas fa-plus me-2"></i>Add Clinic
                          </button>
                        </div>
                        <div v-if="clinicsLoading" class="text-muted mb-3">
                          <span v-if="clinicsLoading" class="spinner-border spinner-border-sm"></span>
                          Loading clinics...
                        </div>
                        <div v-if="adminMessage" class="alert" :class="adminMessageType === 'success' ? 'alert-success' : 'alert-danger'">
                          {{ adminMessage }}
                        </div>

                        <div class="table-responsive clinic-table">
                          <table class="table table-hover table-center mb-0">
                            <thead>
                              <tr>
                                <th>Clinic ID</th>
                                <th>Name</th>
                                <th>Location</th>
                                <th>Contact</th>
                                <th>Email</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-if="!clinicsLoading && clinics.length === 0">
                                <td colspan="5" class="text-center text-muted py-4">No clinics found</td>
                              </tr>
                              <tr v-for="clinic in clinics" :key="clinic.clinicid">
                                <td><strong>{{ clinic.clinicid }}</strong></td>
                                <td>
                                  <div>{{ clinic.clinicname }}</div>
                                  <small class="text-muted">{{ clinic.clinicaddress }}</small>
                                </td>
                                <td>{{ clinic.locationname || "N/A" }}</td>
                                <td>{{ clinic.contactnumbers }}</td>
                                <td>{{ clinic.email || "N/A" }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div v-if="adminPanel === 'cities'" class="card admin-tool-card">
                      <div class="card-body">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                          <h5 class="mb-0">Cities</h5>
                          <button class="btn btn-primary btn-sm" @click="openCityModal()">
                            <i class="fas fa-plus me-2"></i>Add City
                          </button>
                        </div>
                        <div v-if="citiesLoading" class="text-muted mb-3">
                          <span class="spinner-border spinner-border-sm"></span>
                          Loading cities...
                        </div>
                        <div v-if="adminMessage" class="alert" :class="adminMessageType === 'success' ? 'alert-success' : 'alert-danger'">
                          {{ adminMessage }}
                        </div>

                        <div class="row mb-3">
                          <div class="col-md-6">
                            <input
                              v-model="citySearch"
                              type="text"
                              class="form-control"
                              placeholder="Search by city or state"
                            />
                          </div>
                          <div class="col-md-4">
                            <select v-model="cityStatusFilter" class="form-select">
                              <option value="all">All</option>
                              <option value="active">Active only</option>
                              <option value="inactive">Inactive only</option>
                            </select>
                          </div>
                        </div>

                        <div class="table-responsive clinic-table">
                          <table class="table table-hover table-center mb-0">
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>State</th>
                                <th>Country</th>
                                <th>Status</th>
                                <th class="text-end">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-if="!citiesLoading && filteredCities.length === 0">
                                <td colspan="5" class="text-center text-muted py-4">No cities found</td>
                              </tr>
                              <tr v-for="city in filteredCities" :key="city.city_id">
                                <td><strong>{{ city.name }}</strong></td>
                                <td>{{ city.state || "N/A" }}</td>
                                <td>{{ city.country }}</td>
                                <td>
                                  <span
                                    class="badge"
                                    :class="city.is_active ? 'bg-success-light' : 'bg-danger-light'"
                                  >{{ city.is_active ? "Active" : "Inactive" }}</span>
                                </td>
                                <td class="text-end">
                                  <button class="btn btn-sm btn-outline-secondary me-2" @click="openCityModal(city)">
                                    <i class="fas fa-pen"></i>
                                  </button>
                                  <button
                                    class="btn btn-sm"
                                    :class="city.is_active ? 'btn-outline-danger' : 'btn-outline-success'"
                                    :disabled="citiesLoading"
                                    @click="toggleCityStatus(city)"
                                  >{{ city.is_active ? "Deactivate" : "Activate" }}</button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <p class="text-muted mt-3 mb-0" style="font-size: 12px;">
                          Deactivating a city keeps it in the database and leaves existing
                          doctors, clinics and bookings untouched - it only hides the city
                          from the booking and search dropdowns.
                        </p>
                      </div>
                    </div>

                    <div v-if="adminPanel === 'assign-clinics'" class="card admin-tool-card">
                      <div class="card-body">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                          <h5 class="mb-0">Assign Clinics</h5>
                          <span v-if="clinicsLoading" class="spinner-border spinner-border-sm"></span>
                        </div>
                        <div v-if="adminMessage" class="alert" :class="adminMessageType === 'success' ? 'alert-success' : 'alert-danger'">
                          {{ adminMessage }}
                        </div>
                        <div class="assign-panel">
                          <div class="row">
                            <div class="col-md-5">
                              <label class="form-label">Doctor</label>
                              <select v-model="assignmentForm.doctorid" class="form-select" @change="onAssignDoctorChange">
                                <option :value="null">Select doctor</option>
                                <option v-for="doctor in doctors" :key="doctor.doctorid" :value="doctor.doctorid">
                                  {{ doctor.doctorname }} - {{ doctor.status }}
                                </option>
                              </select>
                            </div>
                            <div class="col-md-5">
                              <label class="form-label">Clinics to Assign</label>
                              <select v-model="assignmentForm.clinicids" class="form-select multi-select" multiple :disabled="!assignmentForm.doctorid">
                                <option v-for="clinic in unassignedClinicsForDoctor" :key="clinic.clinicid" :value="clinic.clinicid">
                                  {{ clinic.clinicname }} ({{ clinic.clinicid }})
                                </option>
                              </select>
                            </div>
                            <div class="col-md-2 d-flex align-items-end">
                              <button class="btn btn-secondary w-100" :disabled="clinicsLoading || assignmentForm.clinicids.length === 0" @click="assignClinicsToDoctor">
                                <i class="fas fa-link me-2"></i>Assign
                              </button>
                            </div>
                          </div>
                        </div>

                        <div class="slot-section">
                          <div class="d-flex justify-content-between align-items-center mb-2">
                            <h6 class="mb-0">Assigned Clinics</h6>
                            <span class="schedule-count">{{ assignedDoctorClinics.length }} clinic{{ assignedDoctorClinics.length === 1 ? "" : "s" }}</span>
                          </div>
                          <div v-if="!assignmentForm.doctorid" class="empty-state">
                            Select a doctor to view assigned clinics.
                          </div>
                          <div v-else-if="assignedDoctorClinics.length === 0" class="empty-state">
                            No clinics assigned to this doctor yet.
                          </div>
                          <div v-else class="assigned-clinic-grid">
                            <div v-for="clinic in assignedDoctorClinics" :key="clinic.clinicid" class="assigned-clinic">
                              <strong>{{ clinic.clinicname }}</strong>
                              <span>{{ clinic.clinicid }}</span>
                              <small>{{ clinic.clinicaddress || "No address" }}</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="adminPanel === 'slots'" class="card admin-tool-card">
                      <div class="card-body">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                          <h5 class="mb-0">Doctor Slots</h5>
                          <span v-if="slotsLoading" class="spinner-border spinner-border-sm"></span>
                        </div>
                        <div v-if="adminMessage" class="alert" :class="adminMessageType === 'success' ? 'alert-success' : 'alert-danger'">
                          {{ adminMessage }}
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <label class="form-label">Doctor</label>
                            <select v-model="slotDoctorId" class="form-select" @change="onSlotDoctorChange">
                              <option :value="null">Select doctor</option>
                              <option v-for="doctor in doctors" :key="doctor.doctorid" :value="doctor.doctorid">
                                {{ doctor.doctorname }} - {{ doctor.status }}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-6">
                            <label class="form-label">Clinic</label>
                            <select v-model="slotClinicId" class="form-select" @change="fetchDoctorSlots">
                              <option value="">Select clinic</option>
                              <option v-for="clinic in doctorClinics" :key="clinic.clinicid" :value="clinic.clinicid">
                                {{ clinic.clinicname }} ({{ clinic.clinicid }})
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="slot-section">
                          <div class="d-flex justify-content-between align-items-center mb-2">
                            <h6 class="mb-0">Schedule Times Created by Doctor</h6>
                            <span class="schedule-count">{{ filteredSchedules.length }} schedule{{ filteredSchedules.length === 1 ? "" : "s" }}</span>
                          </div>
                          <div v-if="!slotDoctorId || !slotClinicId" class="empty-state">
                            Select a doctor and clinic to see the doctor-created schedule.
                          </div>
                          <div v-else-if="filteredSchedules.length === 0" class="empty-state">
                            No schedule time found for this doctor and clinic. Ask the doctor to create schedule timing first.
                          </div>
                          <div v-else class="schedule-grid">
                            <div v-for="schedule in filteredSchedules" :key="schedule.slno" class="schedule-row">
                              <div>
                                <strong>{{ schedule.weekday }}</strong>
                                <span>{{ formatTime(schedule.starttime) }} - {{ formatTime(schedule.endtime) }}</span>
                              </div>
                              <span class="slot-pill">{{ schedule.appointduration }} mins</span>
                            </div>
                          </div>
                        </div>

                        <div class="slot-section">
                          <h6>Generate Available Slots</h6>
                          <div class="row">
                            <div class="col-md-4">
                              <label class="form-label">Start Date</label>
                              <input v-model="generateForm.startdate" type="date" class="form-control" />
                            </div>
                            <div class="col-md-4">
                              <label class="form-label">End Date</label>
                              <input v-model="generateForm.enddate" type="date" class="form-control" />
                            </div>
                            <div class="col-md-4 d-flex align-items-end">
                              <button class="btn btn-primary w-100" :disabled="slotsLoading" @click="generateSlots">
                                <i class="fas fa-calendar-check me-2"></i>Generate Slots
                              </button>
                            </div>
                          </div>
                        </div>

                        <div class="slot-section">
                          <div class="d-flex justify-content-between align-items-center mb-2">
                            <h6 class="mb-0">Existing Slots</h6>
                            <button class="btn btn-sm btn-outline-secondary" :disabled="!slotDoctorId || slotsLoading" @click="fetchDoctorSlots">
                              <i class="fas fa-sync-alt"></i>
                            </button>
                          </div>
                          <div v-if="filteredSlots.length === 0" class="text-muted py-3">
                            No slots found for this doctor and clinic.
                          </div>
                          <div v-else class="slot-list">
                            <div v-for="slot in filteredSlots" :key="`${slot.clinicid}-${slot.day}`" class="slot-day">
                              <div class="slot-date">{{ formatDate(slot.day) }}</div>
                              <div class="slot-times">
                                <span v-for="time in slot.times.filter(Boolean)" :key="time" class="slot-pill">{{ time }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                <!-- Filter Section -->
                <div v-show="adminPanel === 'doctors'" class="card mb-3">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6 col-lg-3">
                        <label class="form-label">Filter by Status</label>
                        <select v-model="filterStatus" class="form-select">
                          <option value="all">All Doctors</option>
                          <option value="active">Active</option>
                          <option value="pending">Pending</option>
                          <option value="rejected">Rejected</option>
                        </select>
                      </div>
                      <div class="col-md-6 col-lg-3">
                        <label class="form-label">Search Doctor</label>
                        <input 
                          v-model="searchQuery" 
                          type="text" 
                          class="form-control" 
                          placeholder="Search by name or email..."
                        />
                      </div>
                      <div class="col-md-6 col-lg-3">
                        <label class="form-label">&nbsp;</label>
                        <button @click="resetFilters" class="btn btn-secondary w-100">
                          <i class="fas fa-redo"></i> Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Doctors Table -->
                <div v-show="adminPanel === 'doctors'" class="card card-table mb-0">
                  <div class="card-body">
                    <div class="table-responsive">
                      <table class="table table-hover table-center mb-0">
                        <thead>
                          <tr>
                            <th>Picture</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Contact Number</th>
                            <th>Area</th>
                            <!-- <th>Created Date</th> -->
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="loading">
                            <td colspan="8" class="text-center py-4">
                                <span class="spinner-border spinner-border-sm me-2"></span>
                                Loading doctors...
                              </td>
                            </tr>
                          <tr v-if="!loading && paginatedDoctors.length === 0">
                              <td colspan="8" class="text-center text-muted py-4">
                                No doctors found
                              </td>
                          </tr>
                          <tr v-if="!loading && paginatedDoctors.length !== 0" v-for="doctor in paginatedDoctors" :key="doctor.doctorid" :class="{ 'rejected-row': doctor.status === 'rejected' }">
                            <!-- Picture -->
                            <td>
                              <img 
                                :src="doctor.picture || '@/assets/img/user-placeholder.png'" 
                                class="avatar avatar-xs rounded-circle" 
                                :alt="doctor.doctorname"
                                @click="openDoctorModal(doctor)"
                                style="cursor: pointer;"
                              />
                            </td>
                            <!-- Name -->
                            <td>
                              <h6 class="mb-0" @click="openDoctorModal(doctor)" style="cursor: pointer;">{{ doctor.doctorname }}</h6>
                            </td>
                            <!-- Email -->
                            <td>
                              <p class="mb-0">{{ doctor.email }}</p>
                            </td>
                            <!-- Contact Number -->
                            <td>
                              <p class="mb-0">{{ doctor.contactnumbers }}</p>
                            </td>
                            <!-- Area -->
                            <td>
                              <p class="mb-0">{{ doctor.area }}</p>
                            </td>
                            <!-- Created Date -->
                            <!-- <td>
                              <p class="mb-0">{{ formatDate(doctor.createdDate) }}</p>
                            </td> -->
                            <!-- Status -->
                            <td>
                              <div class="status-toggle">
                                <!-- Rejected Badge (Non-interactive) -->
                                <span v-if="doctor.status === 'rejected'" class="badge bg-danger">Rejected</span>
                                
                                <!-- Pending Badge (Non-interactive) -->
                                <span v-else-if="doctor.status === 'pending'" class="badge bg-warning">Pending</span>
                                
                                <!-- Active/Inactive Toggle (For Approved Doctors) -->
                                <button 
                                  v-else
                                  class="toggle-btn" 
                                  :disabled="loading"
                                  :class="{ active: doctor.status === 'active', inactive: doctor.status === 'inactive' }"
                                  @click="toggleDoctorStatus(doctor)"
                                  :title="doctor.status === 'active' ? 'Click to make inactive' : 'Click to make active'"
                                >
                                  <span class="toggle-label">{{ doctor.status === 'active' ? 'Active' : 'Inactive' }}</span>
                                </button>
                              </div>
                            </td>
                            <!-- Actions -->
                            <td class="text-end">
                              <div class="dropdown dropdown-action">
                                <button 
                                  class="btn btn-sm bg-primary-light btn-sm" 
                                  type="button" 
                                  @click="openDoctorModal(doctor)"
                                >
                                  <i class="fas fa-eye"></i> View
                                </button>
                                <button
                                  class="btn btn-sm bg-info-light ms-2"
                                  type="button"
                                  @click="openSlotManager(doctor)"
                                >
                                  <i class="fas fa-calendar-alt"></i> Slots
                                </button>
                                <button 
                                  v-if="doctor.status === 'pending'"
                                  class="btn btn-sm bg-success-light ms-2" 
                                  type="button"
                                  :disabled="loading"
                                  @click="approvePendingDoctor(doctor)"
                                >
                                  <i class="fas fa-check"></i> Approve
                                </button>
                                <button 
                                  v-if="doctor.status === 'pending'"
                                  class="btn btn-sm bg-danger-light ms-2" 
                                  type="button"
                                  :disabled="loading"
                                  @click="rejectDoctor(doctor)"
                                >
                                  <i class="fas fa-times"></i> Reject
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <!-- Pagination -->
                <div v-show="adminPanel === 'doctors'" class="row">
                  <div class="col-md-12 d-flex justify-content-between align-items-center mt-3">
                    <div class="text-muted">
                      Showing
                      {{ (pagination.page - 1) * pagination.per_page + 1 }}
                      to
                      {{ Math.min(pagination.page * pagination.per_page, pagination.total) }}
                      of
                      {{ pagination.total }}
                      doctors
                    </div>
                    <nav aria-label="Page navigation">
                      <ul class="pagination">
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                          <button class="page-link" @click="changePage(1)" :disabled="currentPage === 1">
                            First
                          </button>
                        </li>

                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                          <button class="page-link" @click="changePage(currentPage - 1)" :disabled="currentPage === 1">
                            Previous
                          </button>
                        </li>

                        <li
                          v-for="page in visiblePages"
                          :key="page"
                          class="page-item"
                          :class="{ active: page === currentPage }"
                        >
                          <button class="page-link" @click="changePage(page)">
                            {{ page }}
                          </button>
                        </li>

                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                          <button class="page-link" @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages">
                            Next
                          </button>
                        </li>

                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                          <button class="page-link" @click="changePage(totalPages)" :disabled="currentPage === totalPages">
                            Last
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Add Clinic Modal -->
    <div v-if="showClinicModal" class="modal-overlay" @click="closeClinicModal">
      <div class="modal-content clinic-modal" @click.stop>
        <div class="modal-header">
          <h5 class="modal-title">Add Clinic</h5>
          <button
            type="button"
            class="btn-close"
            aria-label="Close"
            @click="closeClinicModal"
          ></button>
        </div>
        <div class="modal-body">
          <div v-if="adminMessage" class="alert" :class="adminMessageType === 'success' ? 'alert-success' : 'alert-danger'">
            {{ adminMessage }}
          </div>
          <div class="row">
            <div class="col-md-4">
              <label class="form-label">Clinic ID</label>
              <input v-model.trim="clinicForm.clinicid" class="form-control" maxlength="10" placeholder="CITYHOSP1" />
            </div>
            <div class="col-md-8">
              <label class="form-label">Clinic Name</label>
              <input v-model.trim="clinicForm.clinicname" class="form-control" maxlength="100" />
            </div>
            <div class="col-md-4 mt-3">
              <label class="form-label">Location</label>
              <select v-model="clinicForm.city_id" class="form-select" @change="onClinicCityChange">
                <option :value="null" disabled>
                  {{ citiesLoading ? "Loading cities..." : "Select city" }}
                </option>
                <option v-for="city in activeCities" :key="city.city_id" :value="city.city_id">
                  {{ city.name }}
                </option>
              </select>
            </div>
            <div class="col-md-4 mt-3">
              <label class="form-label">Contact Number</label>
              <input v-model.trim="clinicForm.contactnumbers" class="form-control" maxlength="50" />
            </div>
            <div class="col-md-4 mt-3">
              <label class="form-label">Email</label>
              <input v-model.trim="clinicForm.email" class="form-control" maxlength="100" />
            </div>
            <div class="col-md-8 mt-3">
              <label class="form-label">Address</label>
              <textarea v-model.trim="clinicForm.clinicaddress" class="form-control" rows="2" maxlength="500"></textarea>
            </div>
            <div class="col-md-4 mt-3">
              <label class="form-label">Assign to Doctor</label>
              <select v-model="clinicForm.doctorid" class="form-select">
                <option :value="null">No doctor</option>
                <option v-for="doctor in doctors" :key="doctor.doctorid" :value="doctor.doctorid">
                  {{ doctor.doctorname }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeClinicModal">Cancel</button>
          <button class="btn btn-primary" :disabled="clinicsLoading" @click="createClinic">
            <span v-if="clinicsLoading" class="spinner-border spinner-border-sm me-2"></span>
            <i class="fas fa-plus me-2"></i>Create Clinic
          </button>
        </div>
      </div>
    </div>

    <div v-if="showCityModal" class="modal-overlay" @click="closeCityModal">
      <div class="modal-content clinic-modal" @click.stop>
        <div class="modal-header">
          <h5 class="modal-title">{{ cityForm.city_id ? "Edit City" : "Add City" }}</h5>
          <button
            type="button"
            class="btn-close"
            aria-label="Close"
            @click="closeCityModal"
          ></button>
        </div>
        <div class="modal-body">
          <div v-if="cityFormError" class="alert alert-danger">{{ cityFormError }}</div>
          <div class="row">
            <div class="col-md-12">
              <label class="form-label">City Name</label>
              <input v-model.trim="cityForm.name" class="form-control" maxlength="100" placeholder="Udupi" />
            </div>
            <div class="col-md-6 mt-3">
              <label class="form-label">State</label>
              <input v-model.trim="cityForm.state" class="form-control" maxlength="100" placeholder="Karnataka" />
            </div>
            <div class="col-md-6 mt-3">
              <label class="form-label">Country</label>
              <input v-model.trim="cityForm.country" class="form-control" maxlength="100" placeholder="India" />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeCityModal">Cancel</button>
          <button class="btn btn-primary" :disabled="citiesLoading" @click="saveCity">
            <span v-if="citiesLoading" class="spinner-border spinner-border-sm me-2"></span>
            <i class="fas fa-save me-2"></i>Save City
          </button>
        </div>
      </div>
    </div>

    <!-- Doctor Info Modal -->
    <div v-if="selectedDoctor" class="modal-overlay" @click="closeDoctorModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h5 class="modal-title">Doctor Information</h5>
          <button 
            type="button" 
            class="btn-close" 
            aria-label="Close"
            @click="closeDoctorModal"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <!-- Doctor Picture -->
            <div class="col-md-4 text-center">
              <img 
                :src="selectedDoctor.picture || '@/assets/img/user-placeholder.png'" 
                class="rounded-circle mb-3"
                style="width: 150px; height: 150px; object-fit: cover;"
                :alt="selectedDoctor.name"
              />
              <div class="status-badge mt-2">
                <span v-if="selectedDoctor.status === 'active'" class="badge bg-success">Active</span>
                <span v-else class="badge bg-warning">Pending</span>
              </div>
            </div>
            <!-- Doctor Details -->
            <div class="col-md-8">
              <div class="info-section">
                <h6 class="text-muted">Name</h6>
                <p class="mb-3">{{ selectedDoctor.doctorname }}</p>

                <h6 class="text-muted">Email</h6>
                <p class="mb-3">{{ selectedDoctor.email }}</p>

                <h6 class="text-muted">Contact Number</h6>
                <p class="mb-3">{{ selectedDoctor.contactnumbers}}</p>

                <h6 class="text-muted">Area</h6>
                <p class="mb-3">{{ selectedDoctor.area }}</p>

                <h6 class="text-muted">Specialty</h6>
                <p class="mb-3">{{ selectedDoctor.specialization }}</p>

                <h6 class="text-muted">Experience</h6>
                <p class="mb-3">{{ selectedDoctor.experience }}</p>

                <!-- <h6 class="text-muted">Created Date</h6>
                <p class="mb-3">{{ formatDate(selectedDoctor.createdDate) }}</p> -->
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button 
            v-if="selectedDoctor.status === 'pending'"
            type="button" 
            :disabled="loading"
            class="btn btn-success"
            @click="approveDoctorFromModal"
          >
            <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
            <i class="fas fa-check me-2"></i>Approve
          </button>
          <button 
            v-if="selectedDoctor.status === 'pending'"
            type="button" 
            class="btn btn-danger"
            @click="rejectDoctorFromModal"
          >
            <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
            <i class="fas fa-times me-2"></i>Reject
          </button>
          <button 
            type="button" 
            class="btn btn-secondary"
            @click="closeDoctorModal"
          >
            Close
          </button>
        </div>
      </div>
    </div>

    <indexfooter />
  </div>
</template>

<script>
import { signOut } from 'aws-amplify/auth';
import "vue3-circle-progress/dist/circle-progress.css";
import axios from "axios";
import defaultImageUrl from "@/assets/img/doctors/doctor-thumb-01.jpg";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;

export default {
  components: {
  },
  data() {
  return {
    doctors: [],
    doctorImage: {},
    fetchedImages: {},
    defaultImageUrl,

    pagination: {
      page: 1,
      per_page: 10,
      total: 0,
      total_pages: 1
    },

    stats: {
      total: 0,
      active: 0,
      pending: 0
    },
    statsLoading: false,

    currentPage: 1,
    itemsPerPage: 10,

    filterStatus: "all",
    searchQuery: "",
    loading: false,

    selectedDoctorId: null,
    adminPanel: "doctors",
    adminMessage: "",
    adminMessageType: "success",
    clinicsLoading: false,
    slotsLoading: false,
    showClinicModal: false,
    clinics: [],
    doctorClinics: [],
    assignedDoctorClinics: [],
    doctorSchedules: [],
    doctorSlots: [],
    slotDoctorId: null,
    slotClinicId: "",
    adminCities: [],
    citiesLoading: false,
    citySearch: "",
    cityStatusFilter: "all",
    showCityModal: false,
    cityForm: {
      city_id: null,
      name: "",
      state: "",
      country: "India"
    },
    cityFormError: "",
    clinicForm: {
      clinicid: "",
      clinicname: "",
      locationname: "",
      city_id: null,
      clinicaddress: "",
      contactnumbers: "",
      email: "",
      doctorid: null
    },
    assignmentForm: {
      doctorid: null,
      clinicids: []
    },
    generateForm: {
      startdate: "",
      enddate: ""
    }
  };
},
  computed: {
    totalDoctors() {
      return this.pagination?.total || 0;
    },
    activeDoctors() {
      return this.stats?.active || 0;
    },
    pendingDoctors() {
      return this.stats?.pending || 0;
    },
    paginatedDoctors() {
      return this.doctors;
    },
    totalPages() {
      return this.pagination?.total_pages || 1;
    },
    selectedDoctor() {
    return this.doctors.find(d => d.doctorid === this.selectedDoctorId) || null;
    },
    filteredSlots() {
      if (!this.slotClinicId) return this.doctorSlots;
      return this.doctorSlots.filter(slot => slot.clinicid === this.slotClinicId);
    },
    filteredSchedules() {
      if (!this.slotClinicId) return this.doctorSchedules;
      return this.doctorSchedules.filter(schedule => schedule.clinicid === this.slotClinicId);
    },
    // Active cities only, for the clinic location dropdown.
    activeCities() {
      return this.adminCities.filter(city => city.is_active);
    },
    filteredCities() {
      const term = this.citySearch.trim().toLowerCase();
      return this.adminCities.filter(city => {
        if (this.cityStatusFilter === "active" && !city.is_active) return false;
        if (this.cityStatusFilter === "inactive" && city.is_active) return false;
        if (!term) return true;
        return (
          city.name.toLowerCase().includes(term) ||
          (city.state || "").toLowerCase().includes(term)
        );
      });
    },
    unassignedClinicsForDoctor() {
      const assignedIds = new Set(this.assignedDoctorClinics.map(clinic => clinic.clinicid));
      return this.clinics.filter(clinic => !assignedIds.has(clinic.clinicid));
    },
    visiblePages() {
      const pages = [];
      const maxVisible = 5;
      let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
      let end = Math.min(this.totalPages, start + maxVisible - 1);

      if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    }
  },
  methods: {
    setAdminMessage(message, type = "success") {
      this.adminMessage = message;
      this.adminMessageType = type;
      setTimeout(() => {
        this.adminMessage = "";
      }, 5000);
    },
    // Keep locationname in step with the selected city so the legacy column
    // stays populated for existing reports.
    onClinicCityChange() {
      const city = this.activeCities.find(c => c.city_id === this.clinicForm.city_id);
      this.clinicForm.locationname = city ? city.name.slice(0, 25) : "";
    },
    openCitiesPanel() {
      this.adminPanel = "cities";
      this.fetchAdminCities();
    },
    resetCityForm() {
      this.cityForm = { city_id: null, name: "", state: "", country: "India" };
      this.cityFormError = "";
    },
    openCityModal(city = null) {
      this.resetCityForm();
      if (city) {
        this.cityForm = {
          city_id: city.city_id,
          name: city.name,
          state: city.state || "",
          country: city.country || "India"
        };
      }
      this.showCityModal = true;
    },
    closeCityModal() {
      this.showCityModal = false;
      this.resetCityForm();
    },
    // The admin list includes inactive cities, so it is fetched separately
    // from the shared active-only list used by the booking dropdowns.
    async fetchAdminCities() {
      this.citiesLoading = true;
      try {
        const response = await axios.get("/cities/admin");
        this.adminCities = response.data || [];
      } catch (error) {
        console.error("Failed to load cities", error);
        this.setAdminMessage("Failed to load cities", "error");
      } finally {
        this.citiesLoading = false;
      }
    },
    async saveCity() {
      const name = this.cityForm.name.trim().replace(/\s+/g, " ");
      if (!name) {
        this.cityFormError = "Please enter a city name.";
        return;
      }
      if (name.length > 100) {
        this.cityFormError = "City name must not exceed 100 characters.";
        return;
      }

      const payload = {
        name,
        state: this.cityForm.state.trim() || null,
        country: this.cityForm.country.trim() || "India"
      };

      this.citiesLoading = true;
      try {
        if (this.cityForm.city_id) {
          await axios.put(`/cities/${this.cityForm.city_id}`, payload);
          this.setAdminMessage("City updated successfully.");
        } else {
          // POST /cities returns the existing record when one matches, so a
          // duplicate name never creates a second row.
          await axios.post("/cities", payload);
          this.setAdminMessage("City saved successfully.");
        }
        this.closeCityModal();
        await this.refreshCities();
      } catch (error) {
        console.error("Failed to save city", error);
        this.cityFormError = error.response?.data?.detail || "Failed to save city";
      } finally {
        this.citiesLoading = false;
      }
    },
    async toggleCityStatus(city) {
      this.citiesLoading = true;
      try {
        await axios.patch(`/cities/${city.city_id}/status`, null, {
          params: { is_active: !city.is_active }
        });
        this.setAdminMessage(
          `${city.name} is now ${city.is_active ? "inactive" : "active"}.`
        );
        await this.refreshCities();
      } catch (error) {
        console.error("Failed to update city status", error);
        this.setAdminMessage(error.response?.data?.detail || "Failed to update city status", "error");
      } finally {
        this.citiesLoading = false;
      }
    },
    // Refresh both the admin list and the shared active-city list the booking
    // dropdowns read, so an admin change shows up without a page reload.
    async refreshCities() {
      await this.fetchAdminCities();
      await this.$store.dispatch("loadCities", { force: true });
    },
    resetClinicForm() {
      this.clinicForm = {
        clinicid: "",
        clinicname: "",
        locationname: "",
        city_id: null,
        clinicaddress: "",
        contactnumbers: "",
        email: "",
        doctorid: null
      };
    },
    openClinicModal() {
      this.resetClinicForm();
      this.showClinicModal = true;
    },
    closeClinicModal() {
      this.showClinicModal = false;
      this.resetClinicForm();
    },
    initGenerateDates() {
      const today = new Date();
      const endDate = new Date();
      endDate.setDate(today.getDate() + 30);
      this.generateForm.startdate = today.toISOString().slice(0, 10);
      this.generateForm.enddate = endDate.toISOString().slice(0, 10);
    },
    async fetchClinics() {
      this.clinicsLoading = true;
      try {
        const response = await axios.get("/doctors/clinichospital");
        this.clinics = response.data || [];
      } catch (error) {
        console.error("Failed to load clinics", error);
        this.setAdminMessage("Failed to load clinics", "error");
      } finally {
        this.clinicsLoading = false;
      }
    },
    async createClinic() {
      if (!this.clinicForm.clinicid || !this.clinicForm.clinicname || !this.clinicForm.locationname || !this.clinicForm.contactnumbers) {
        this.setAdminMessage("Clinic ID, name, location, and contact number are required.", "error");
        return;
      }

      this.clinicsLoading = true;
      try {
        const payload = {
          ...this.clinicForm,
          clinicid: this.clinicForm.clinicid.toUpperCase(),
          doctorid: this.clinicForm.doctorid || null
        };
        await axios.post("/doctors/clinichospital", payload);
        this.setAdminMessage("Clinic created successfully.");
        this.closeClinicModal();
        await this.fetchClinics();
        if (this.slotDoctorId) {
          await this.fetchDoctorClinics();
        }
        if (this.assignmentForm.doctorid && this.assignmentForm.doctorid === payload.doctorid) {
          await this.onAssignDoctorChange();
        }
      } catch (error) {
        console.error("Failed to create clinic", error);
        this.setAdminMessage(error.response?.data?.detail || "Failed to create clinic", "error");
      } finally {
        this.clinicsLoading = false;
      }
    },
    async onAssignDoctorChange() {
      this.assignmentForm.clinicids = [];
      this.assignedDoctorClinics = [];
      if (!this.assignmentForm.doctorid) return;

      this.clinicsLoading = true;
      try {
        const response = await axios.get(`/doctors/${this.assignmentForm.doctorid}/clinicids`, {
          params: { details: true }
        });
        this.assignedDoctorClinics = response.data || [];
      } catch (error) {
        console.error("Failed to load assigned clinics", error);
        this.setAdminMessage("Failed to load assigned clinics for selected doctor", "error");
      } finally {
        this.clinicsLoading = false;
      }
    },
    async assignClinicsToDoctor() {
      if (!this.assignmentForm.doctorid || this.assignmentForm.clinicids.length === 0) {
        this.setAdminMessage("Select a doctor and at least one clinic before assigning.", "error");
        return;
      }

      this.clinicsLoading = true;
      try {
        await Promise.all(
          this.assignmentForm.clinicids.map(clinicid =>
            axios.post(`/doctors/${this.assignmentForm.doctorid}/clinics/${clinicid}/link`)
          )
        );
        this.setAdminMessage("Selected clinics assigned to doctor.");
        await this.onAssignDoctorChange();
        if (this.slotDoctorId === this.assignmentForm.doctorid) {
          await this.fetchDoctorClinics();
        }
      } catch (error) {
        console.error("Failed to assign clinics", error);
        this.setAdminMessage(error.response?.data?.detail || "Failed to assign clinics", "error");
      } finally {
        this.clinicsLoading = false;
      }
    },
    async fetchDoctorClinics() {
      this.doctorClinics = [];
      this.slotClinicId = "";
      if (!this.slotDoctorId) return;

      try {
        const response = await axios.get(`/doctors/${this.slotDoctorId}/clinicids`, {
          params: { details: true }
        });
        this.doctorClinics = response.data || [];
        if (this.doctorClinics.length > 0) {
          this.slotClinicId = this.doctorClinics[0].clinicid;
        }
      } catch (error) {
        console.error("Failed to load doctor clinics", error);
        this.setAdminMessage("Failed to load clinics for selected doctor", "error");
      }
    },
    async fetchDoctorSchedules() {
      this.doctorSchedules = [];
      if (!this.slotDoctorId) return;

      try {
        const response = await axios.get(`/doctors/${this.slotDoctorId}/scheduletiming`);
        this.doctorSchedules = response.data || [];
      } catch (error) {
        console.error("Failed to load doctor schedule times", error);
        this.setAdminMessage("Failed to load doctor schedule times", "error");
      }
    },
    async onSlotDoctorChange() {
      await this.fetchDoctorClinics();
      await this.fetchDoctorSchedules();
      await this.fetchDoctorSlots();
    },
    async fetchDoctorSlots() {
      this.doctorSlots = [];
      if (!this.slotDoctorId || !this.generateForm.startdate || !this.generateForm.enddate) return;

      this.slotsLoading = true;
      try {
        const response = await axios.get(`/doctors/${this.slotDoctorId}/slots`, {
          params: {
            starttime: this.generateForm.startdate,
            endtime: this.generateForm.enddate
          }
        });
        this.doctorSlots = response.data?.timeslots || [];
      } catch (error) {
        if (error.response?.status !== 404) {
          console.error("Failed to load slots", error);
          this.setAdminMessage("Failed to load doctor slots", "error");
        }
      } finally {
        this.slotsLoading = false;
      }
    },
    async generateSlots() {
      if (!this.slotDoctorId || !this.slotClinicId) {
        this.setAdminMessage("Select a doctor and clinic first.", "error");
        return;
      }
      if (!this.generateForm.startdate || !this.generateForm.enddate || this.generateForm.startdate > this.generateForm.enddate) {
        this.setAdminMessage("Enter a valid date range.", "error");
        return;
      }
      if (this.filteredSchedules.length === 0) {
        this.setAdminMessage("This clinic has no doctor-created schedule time. Ask the doctor to create schedule timing first.", "error");
        return;
      }

      this.slotsLoading = true;
      try {
        const response = await axios.post(
          `/doctors/${this.slotDoctorId}/generate-slot/${this.slotClinicId}`,
          {
            startdate: this.generateForm.startdate,
            enddate: this.generateForm.enddate
          }
        );
        this.setAdminMessage(response.data?.detail || "Slots generated successfully.");
        await this.fetchDoctorSlots();
      } catch (error) {
        console.error("Failed to generate slots", error);
        this.setAdminMessage(error.response?.data?.detail || "Failed to generate slots", "error");
      } finally {
        this.slotsLoading = false;
      }
    },
    async openSlotManager(doctor) {
      this.adminPanel = "slots";
      this.slotDoctorId = doctor.doctorid;
      await this.onSlotDoctorChange();
    },
    async fetchDoctorStats() {
    this.statsLoading = true;

    try {
      const response = await axios.get("/doctors/stats");
      this.stats = response.data;
    } catch (error) {
      console.error("Failed to load doctor stats", error);
    } finally {
      this.statsLoading = false;
    }
  },
    changePage(page) {
        if (page < 1 || page > this.totalPages) return;

        this.currentPage = page;
        this.fetchDoctors();
    },
    async fetchDoctors() {
      try {
        const response = await axios.get("/doctors", {
          params: {
            page: this.currentPage,
            per_page: this.itemsPerPage,
            status: this.filterStatus || null,
            searchtext: this.searchQuery || null
          }
        });

        this.doctors = response.data.doctors;
        this.pagination = response.data.pagination;

      } catch (error) {
        console.error("Error fetching doctors", error);
        this.doctors = [];
      }
    },
    async updateDoctorStatus(doctor, newStatus) {
      try {
        this.loading = true;

        await axios.patch(`/doctors/${doctor.doctorid}/status`, null, {
          params: { status: newStatus }
        });

        // refresh list + stats
        await this.fetchDoctors();
        await this.fetchDoctorStats();

      } catch (error) {
        console.error("Failed to update doctor status", error);
        alert("Failed to update doctor status");
      } finally {
        this.loading = false;
      }
    },
    async fetchDoctorProfileImage(doctorId, doctorImage) {
      if (this.fetchedImages[doctorId]) {
        this.doctorImage[doctorId] = this.fetchedImages[doctorId];
        return;
      }

      if (doctorImage == null) {
        this.doctorImage[doctorId] = this.defaultImageUrl;
        this.fetchedImages[doctorId] = this.defaultImageUrl;
      } else {
        try {
          const response = await axios.get(
            `doctors/doctor-images?profilePath=${doctorImage}`,
            {
              responseType: "arraybuffer"
            }
          );
          const objectURL = window.URL.createObjectURL(
            new Blob([response.data])
          );
          this.doctorImage[doctorId] = objectURL;
          this.fetchedImages[doctorId] = objectURL;
        } catch (error) {
          console.error("Error fetching Doctor profile image:", error);
        }
      }
    },
    applyFilters() {
      this.filteredDoctors = this.doctors;
      this.paginatedDoctors.forEach(doctor => {
        this.fetchDoctorProfileImage(doctor.doctorid, doctor.doctorimage);
      });
    },
    formatDate(date) {
      if (!date) return 'N/A';
      const d = new Date(date);
      return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    },
    formatTime(time) {
      return time ? String(time).slice(0, 5) : "";
    },
    resetFilters() {
      this.filterStatus = "all";
      this.searchQuery = "";
      this.currentPage = 1;
    },
    openDoctorModal(doctor) {
      this.selectedDoctorId = doctor.doctorid;
    },
    closeDoctorModal() {
      this.selectedDoctorId = null;
    },
    toggleDoctorStatus(doctor) {
      const newStatus = doctor.status === "active" ? "inactive" : "active";
      this.updateDoctorStatus(doctor, newStatus);
    },
    approveDoctorFromModal() {
      if (!this.selectedDoctor) return;

      this.updateDoctorStatus(this.selectedDoctor, "active");
      this.closeDoctorModal();
    },
    rejectDoctorFromModal() {
      if (!this.selectedDoctor) return;
      if (!confirm(`Reject ${this.selectedDoctor.doctorname}?`)) return;
      this.updateDoctorStatus(this.selectedDoctor, "rejected");
      this.closeDoctorModal();
    },
    approvePendingDoctor(doctor) {
      this.updateDoctorStatus(doctor, "active");
    },
    rejectDoctor(doctor) {
      if (!confirm(`Reject ${doctor.doctorname}?`)) return;
      this.updateDoctorStatus(doctor, "rejected");
    },
    logout() {
      if (confirm('Are you sure you want to logout?')) {      
      signOut()
      .then(data => {
        this.closeMenu();
      }).catch(err => console.log(err))
        // Clear session and local storage
        sessionStorage.removeItem('useridpid');
        sessionStorage.removeItem('usertype');
        localStorage.removeItem('adminEmail');
        localStorage.removeItem('adminLoggedIn');
      }
    },
  },
mounted() {
  this.initGenerateDates();
  this.fetchDoctors();
  this.fetchDoctorStats();
  this.fetchClinics();
  this.fetchAdminCities();
},
  watch: {
  filterStatus() {
    this.currentPage = 1;
    this.fetchDoctors();
  },
  searchQuery() {
    this.currentPage = 1;
    this.fetchDoctors();
  }
}

};
</script>

<style scoped>
.dash-card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  border: none;
  margin-bottom: 20px;
}

.dash-widget {
  padding: 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 20px;
}

.dct-border-rht {
  border-right: 1px solid #e9ecef;
}

.circle-bar {
  width: 80px;
  height: 80px;
  position: relative;
}

.circle-graph1,
.circle-graph2,
.circle-graph3 {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle-graph1 img,
.circle-graph2 img,
.circle-graph3 img {
  width: 40px;
  height: 40px;
  z-index: 1;
}

.dash-widget-info h6 {
  font-size: 14px;
  color: #6c757d;
  margin-bottom: 5px;
  font-weight: 600;
}

.dash-widget-info h3 {
  font-size: 28px;
  color: #333;
  margin-bottom: 5px;
}

.dash-widget-info p {
  font-size: 13px;
  margin-bottom: 0;
}

.table-hover tbody tr:hover {
  background-color: #f8f9fa;
}

.avatar-xs {
  width: 40px;
  height: 40px;
}

.badge {
  padding: 5px 12px;
  border-radius: 12px;
  font-size: 12px;
}

.bg-success {
  background-color: #28a745 !important;
}

.bg-warning {
  background-color: #ffc107 !important;
}

.pagination {
  gap: 5px;
}

.pagination .page-link {
  border: 1px solid #dee2e6;
  color: #666;
  padding: 8px 12px;
  border-radius: 4px;
}

.pagination .page-link:hover:not(.disabled) {
  background-color: #f8f9fa;
  border-color: #dee2e6;
}

.pagination .page-item.active .page-link {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
}

.pagination .page-item.disabled .page-link {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn {
  border-radius: 4px;
  font-size: 12px;
}

.bg-primary-light {
  background-color: #e7f3ff;
  color: #007bff;
}

.bg-success-light {
  background-color: #d4edda;
  color: #28a745;
}

.bg-danger-light {
  background-color: #f8d7da;
  color: #dc3545;
}

.bg-info-light {
  background-color: #dff4ff;
  color: #0b7fab;
}

.admin-workspace {
  margin-bottom: 20px;
  align-items: flex-start;
}

.admin-sidebar,
.admin-tool-card {
  border: 1px solid #e7edf3;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.04);
}

.admin-sidebar {
  position: sticky;
  top: 90px;
}

.admin-sidebar .card-body {
  display: grid;
  gap: 8px;
}

.admin-nav-btn {
  width: 100%;
  border: 1px solid transparent;
  background: #f8fafc;
  color: #344054;
  border-radius: 6px;
  padding: 10px 12px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
}

.admin-nav-btn i {
  width: 18px;
  margin-right: 8px;
}

.admin-nav-btn.active {
  background: #e7f3ff;
  border-color: #b8dcff;
  color: #007bff;
}

.slot-section {
  border-top: 1px solid #edf2f7;
  margin-top: 20px;
  padding-top: 18px;
}

.slot-section h6 {
  color: #344054;
  font-weight: 700;
  margin-bottom: 14px;
}

.slot-list {
  display: grid;
  gap: 10px;
  max-height: 320px;
  overflow-y: auto;
}

.slot-day {
  border: 1px solid #e7edf3;
  border-radius: 6px;
  padding: 10px;
}

.slot-date {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 8px;
}

.slot-times {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.slot-pill {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  color: #334155;
  font-size: 12px;
  padding: 4px 8px;
}

.empty-state {
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 6px;
  color: #64748b;
  font-size: 13px;
  padding: 14px;
}

.schedule-count {
  color: #667085;
  font-size: 12px;
  font-weight: 600;
}

.schedule-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 10px;
}

.schedule-row {
  align-items: center;
  border: 1px solid #e7edf3;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 10px;
}

.schedule-row strong,
.schedule-row span {
  display: block;
}

.schedule-row strong {
  color: #1f2937;
  font-size: 13px;
}

.schedule-row div > span {
  color: #667085;
  font-size: 12px;
  margin-top: 2px;
}

.assign-panel {
  background: #f8fafc;
  border: 1px solid #e7edf3;
  border-radius: 6px;
  margin-bottom: 18px;
  padding: 14px;
}

.assign-panel h6 {
  color: #344054;
  font-weight: 700;
  margin-bottom: 14px;
}

.clinic-table {
  border: 1px solid #e7edf3;
  border-radius: 6px;
}

.clinic-modal {
  max-width: 780px;
}

.multi-select {
  min-height: 110px;
}

.assigned-clinic-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 10px;
}

.assigned-clinic {
  border: 1px solid #e7edf3;
  border-radius: 6px;
  padding: 12px;
}

.assigned-clinic strong,
.assigned-clinic span,
.assigned-clinic small {
  display: block;
}

.assigned-clinic strong {
  color: #1f2937;
  font-size: 13px;
}

.assigned-clinic span {
  color: #0b7fab;
  font-size: 12px;
  font-weight: 700;
  margin-top: 3px;
}

.assigned-clinic small {
  color: #667085;
  margin-top: 6px;
}

.form-select,
.form-control {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 8px 12px;
}

.form-select:focus,
.form-control:focus {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* Toggle Button Styles */
.status-toggle {
  display: flex;
  justify-content: center;
}

.toggle-btn {
  border: none;
  padding: 6px 16px;
  border-radius: 20px;
  cursor: pointer;
  font-weight: 600;
  font-size: 12px;
  transition: all 0.3s ease;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 8px;
}

.toggle-btn.active {
  background-color: #28a745;
  color: white;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
}

.toggle-btn.active:hover {
  background-color: #218838;
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);
}

.toggle-btn.inactive {
  background-color: #6c757d;
  color: white;
  box-shadow: 0 2px 8px rgba(108, 117, 125, 0.3);
}

.toggle-btn.inactive:hover {
  background-color: #5a6268;
  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.4);
}

.toggle-label {
  font-weight: 600;
}

/* Rejected Row Styling */
.rejected-row {
  background-color: #f5f5f5 !important;
  opacity: 0.6;
  pointer-events: none;
}

.rejected-row td {
  color: #999;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal-content {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #dee2e6;
}

.modal-header .modal-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.modal-header .btn-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  padding: 0;
  transition: color 0.2s;
}

.modal-header .btn-close:hover {
  color: #333;
}

.modal-body {
  padding: 30px 20px;
}

.modal-footer {
  padding: 20px;
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.modal-footer .btn {
  padding: 8px 16px;
  font-size: 14px;
}

.info-section h6 {
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  margin-bottom: 8px;
  color: #999;
}

.info-section p {
  font-size: 14px;
  color: #333;
}

.status-badge {
  margin-top: 10px;
}

.modal-body .row {
  align-items: flex-start;
}
</style>
